/**
 * StreakFlame — la llamita de la racha, con respiración sutil opcional.
 *
 * Reusa el `IconFire` de la home; el wrapper `.streak-flame` aplica la
 * animación `flameBreathe` (apagada con `prefers-reduced-motion`, ver
 * home.css). `animate={false}` la deja estática (tiles, celdas del calendario).
 *
 * `StreakChip` es el chip del header: botón clickeable que abre la hoja
 * "Tu racha". `is-pending` cuando todavía no se practicó hoy.
 */
import { IconFire } from '../icons.js';

interface StreakFlameProps {
  size?: number;
  color?: string;
  animate?: boolean;
}

export function StreakFlame({ size = 16, color = 'var(--streak)', animate = true }: StreakFlameProps) {
  return (
    <span className={animate ? 'streak-flame' : ''} style={{ display: 'flex' }}>
      <IconFire size={size} color={color} />
    </span>
  );
}

interface StreakChipProps {
  count: number;
  todayDone: boolean;
  onClick: () => void;
}

export function StreakChip({ count, todayDone, onClick }: StreakChipProps) {
  return (
    <button
      type="button"
      className={`streak-chip is-btn${todayDone ? '' : ' is-pending'}`}
      onClick={onClick}
      aria-label="Ver tu racha"
    >
      <StreakFlame size={15} color={todayDone ? 'var(--streak)' : 'rgba(255,184,99,0.7)'} />
      <span>{count}</span>
    </button>
  );
}
